import { Component, ReactNode } from "react";
import { FlashMessage } from "./types";

type AddFlashMessageProps = Partial<FlashMessage>;

type State = {
  messages: FlashMessage[];
};

export type RenderProps = State & {
  add: (param?: AddFlashMessageProps) => FlashMessage["id"] | void;
  close: (id: number) => void;
  closeAll: () => void;
};

interface Props {
  children: (props: RenderProps) => ReactNode;
  closeTimeoutDelay?: number;
}

export class FlashMessages extends Component<Props, State> {
  private closeTimers: { [key: number]: NodeJS.Timeout };

  constructor(props: Props) {
    super(props);
    this.state = {
      messages: [],
    };
    this.closeTimers = {};
  }

  componentWillUnmount(): void {
    Object.values(this.closeTimers).forEach((timer) => {
      clearTimeout(timer);
    });
  }

  addCloseTimer = (messageId: number) => {
    if (!this.props.closeTimeoutDelay) return;

    const timer = setTimeout(() => {
      this.close(messageId);
      delete this.closeTimers[messageId];
    }, this.props.closeTimeoutDelay);

    this.closeTimers[messageId] = timer;
  };

  add = (param?: AddFlashMessageProps) => {
    const defaultParam: FlashMessage = {
      ...{
        id: +new Date(),
        text: "Ошибка",
        type: "error",
      },
      ...param,
    };

    const { id, text, type } = defaultParam;

    this.setState((prev) => ({
      ...prev,
      messages: [...prev.messages, { text, id, type }].filter(
        (item, index, arr) =>
          arr.findIndex(
            (innerItem) =>
              innerItem.id === item.id ||
              (innerItem.text === item.text && innerItem.type === item.type)
          ) === index
      ),
    }));

    this.addCloseTimer(id);

    return id;
  };

  close = (id: number) => {
    this.setState((prev) => ({
      ...prev,
      messages: prev.messages.filter((item) => item.id !== id),
    }));
  };

  closeAll = () => {
    this.setState((prev) => ({
      ...prev,
      messages: [],
    }));
  };

  render() {
    return this.props.children({
      messages: this.state.messages,
      add: this.add,
      close: this.close,
      closeAll: this.closeAll,
    });
  }
}
